<template>
  <div>
    <table class="content">
      <tr>
        <td width="40px" class="ctrl-bar" rowspan="2">
          <div class="grip">
            <font-awesome-icon icon="grip-lines" class="icon fa-1x" />
          </div>
          <div class="remove" @click="$emit('remove')">
            <font-awesome-icon icon="minus-square" class="icon fa-2x" />
          </div>
        </td>
        <td :colspan="cols">
          {{title}}
        </td>
    </tr>
    <tr>
      <slot />
    </tr>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    cols: {
      type: Number,
      default: 1
    },
    title: String
  }
}
</script>

<style lang="scss" scoped>
.content {
  background-color: #FFF;
  width: 100%;
  margin: 2px 1px;
}
.ctrl-bar {
  vertical-align: top;
}
.remove {
  color: #F00;
  text-align: center;
  cursor: pointer;
}
.grip {
  width:40px;
  height:60px;
  text-align: center;
  cursor: move;
  margin-top: 10px;
}
</style>
